import React from "react";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";
import EstimateProjectForm from "../../WebDevelopmentPage/EstimateProjectForm";

const highlights = [
  {
    title: "Customer App",
    description: "Book rides, track drivers, pay online, and rate every trip from one interface.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="7" y="2" width="10" height="20" rx="2" stroke="currentColor" strokeWidth="1.5" />
        <path d="M11 18h2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
  },
  {
    title: "Driver App",
    description: "Accept requests, navigate with GPS, manage earnings, and communicate with passengers.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M5 17h14l-1-5H6l-1 5Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
        <path d="M7 12V8a5 5 0 0 1 10 0v4" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="7.5" cy="17.5" r="1.5" fill="currentColor" />
        <circle cx="16.5" cy="17.5" r="1.5" fill="currentColor" />
      </svg>
    ),
  },
  {
    title: "Admin Panel",
    description: "Manage users, drivers, vehicles, rides, tariffs, commissions, and business reports.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <rect x="3" y="4" width="18" height="6" rx="1.5" stroke="currentColor" strokeWidth="1.5" />
        <rect x="3" y="14" width="18" height="6" rx="1.5" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="7" cy="7" r="1" fill="currentColor" />
        <circle cx="7" cy="17" r="1" fill="currentColor" />
      </svg>
    ),
  },
  {
    title: "White-Label Clone",
    description: "Customized Uber/Ola clone built by a top taxi booking app development company in India.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M12 3 4 9v12h16V9l-8-6Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
        <path d="M9 21v-6h6v6" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      </svg>
    ),
  },
];

const TbIntroSection: React.FC = () => {
  return (
    <section className="wdev-intro tb-intro" aria-labelledby="tb-intro-title">
      <div className="container">
        <div className="wdev-intro__grid">
          <AnimatedSection className="wdev-intro__content">
            <span className="wdev-label wdev-label--purple">Taxi Booking Platform</span>
            <h2 id="tb-intro-title" className="wdev-intro__title">
              Taxi Booking App Development
            </h2>

            <p className="wdev-intro__text">
              Build your own taxi booking app like Uber and Ola and earn a hefty profit from your own
              taxi business. Be a reputable taxi industry leader in your region with a customized taxi
              app development solution or a white-label readymade Uber clone application.
            </p>
            <p className="wdev-intro__text">
              WebTech is a top taxi booking app development company in Bangalore, India — delivering
              device-friendly, multi-platform apps with real-time GPS, multi-payment support, and
              end-to-end ride management for passengers, drivers, and administrators.
            </p>

            <div className="wdev-intro__highlights">
              {highlights.map((item) => (
                <div className="wdev-intro__highlight" key={item.title}>
                  <div className="wdev-intro__highlight-icon">{item.icon}</div>
                  <div>
                    <h3 className="wdev-intro__highlight-title">{item.title}</h3>
                    <p className="wdev-intro__highlight-desc">{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </AnimatedSection>

          <AnimatedSection className="wdev-intro__form-wrap" delay={0.15}>
            <EstimateProjectForm />
          </AnimatedSection>
        </div>
      </div>
    </section>
  );
};

export default TbIntroSection;
